import { Container } from '@chakra-ui/react'

import { contentMargin, layoutContainerPadding } from 'theme/space'

const LayoutContainer: React.FC = ({ children }) => (
  <Container
    maxW="container.xl"
    my={contentMargin.lg}
    px={layoutContainerPadding}
    as="main"
    centerContent
    // taken from https://css-tricks.com/couple-takes-sticky-footer/#there-is-flexbox
    flex="1 0 auto"
  >
    {children}
  </Container>
)

export default LayoutContainer
